export default "__VITE_ASSET__Ba2YIbSY__"